import { Injectable } from '@angular/core';
import { MindMapImport } from './mind-map-import.model';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';

@Injectable()
export class MindMapImportService {
    constructor(private fiBackend: FiBackendService) {}

    ReadFileAsync(file: File) {
        const promise = new Promise<string>((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsText(file);
            fileReader.onload = function (e: any) {
                resolve(e.target.result);
            };
        });
        return promise;
    }

    ImportMindMapFile(mindMapImport: MindMapImport) {
        return this.fiBackend.fetchDataPost<void>('Custom/MindMapImport/ImportMindMapFile', mindMapImport, {
            supressErrorMessage: true,
        });
    }

    ImportDocFile(mindMapImport: MindMapImport, file: File) {
        const fd = new FormData();
        fd.append('File', file, file.name);

        fd.append('MindMapImport', JSON.stringify(mindMapImport));

        return this.fiBackend.fetchDataPost('Custom/MindMapImport/ImportDocFile', fd, {
            supressErrorMessage: true,
        });
    }
}
